// Firebase initialization and handling
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import 'firebase/compat/auth';
import 'firebase/compat/database';

// Initialize the Firebase application
export const firebaseApp = initializeApp({
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
});

export const auth = getAuth(firebaseApp);

if (import.meta.env.DEV) {
    connectAuthEmulator(auth, 'http://localhost:9099');
}
